import { render, staticRenderFns } from "./Iam.vue?vue&type=template&id=b40fa962&"
import script from "./Iam.vue?vue&type=script&lang=js&"
export * from "./Iam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports